import type { CohortWithOrganisation } from '@/types/cohorts.ts';

/**
 * A cohort's name, the way a picker says it.
 *
 * The track comes along because a cohort's own title is often just a date or a
 * group number, and the track is what tells two of them apart. Across
 * organisations the organisation is named too — the same "Q1" exists at four
 * customers.
 */
export function cohortLabel(
  cohort: CohortWithOrganisation,
  { withOrganisation }: { withOrganisation: boolean },
): string {
  const label = cohort.track ? `${cohort.title} (${cohort.track.title})` : cohort.title;
  if (!withOrganisation) return label;
  return cohort.organisation.name ? `${cohort.organisation.name} — ${label}` : label;
}
